import {
  FullPageError,
  ImpersonationTopBanner,
} from '@leagueplatform/web-common-components';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

// Shown in place of the routes while the browser is offline. Going offline
// unmounts the routes, and the banner the signed-in routes carry with them, so
// this page brings its own for a support agent.
export const OfflinePage = () => (
  <>
    <ImpersonationTopBanner />
    <FullPageError error={null} route={APP_MANAGED_ROUTES.HOME} />
  </>
);
